import { Icon } from '@beek/design-system';
import Avo from 'src/tracking/Avo';
import Link from 'next/link';
import Logo from '/src/components/Common/Logo/';
import ProgressBar from './ProgressBar';
import styles from './styles.module.css';

type WelcomeHeaderProps = {
  percentComplete?: number;
  hasBackButton?: boolean;
  onBackButtonClick?: () => void;
};

const handleLogoClick = () => {
  Avo.onboardingFlowAborted({
    connectionType: navigator.connection?.type ?? 'unknown',
    isOnline: navigator.onLine,
    origin: 'Onboarding - Beek Logo Clicked',
    referrer: window.location.href,
  });
};

const WelcomeHeader = ({
  percentComplete = 0,
  hasBackButton = false,
  onBackButtonClick = () => {},
}: WelcomeHeaderProps): JSX.Element => (
  <nav className={styles.nav}>
    <div className={styles.header}>
      {hasBackButton && (
        <button
          className={styles.backButton}
          onClick={() => onBackButtonClick()}
        >
          <Icon.ChevronLeft className={styles.backButton} size="large" />
        </button>
      )}
      <Link href="/" onClick={handleLogoClick} legacyBehavior={false}>
        <a className={styles.logo} aria-label="Beek Logo">
          <Logo />
        </a>
      </Link>
      <ProgressBar percentComplete={percentComplete} />
      <div className={styles.spacer} />
    </div>
  </nav>
);

export default WelcomeHeader;
